export const dateFormatWithTime = 'D MMMM YYYY, H:mm';
export const shortDateFormatWithTime = 'D MMM YYYY, H:mm';
export const dateFormat = 'D MMMM YYYY';
